// Lightweight copy-to-clipboard handler.
//
// Markup contract:
//   <button data-copy-target="#some-input" data-copy-label="Copiado">Copiar</button>
//   <input id="some-input" value="..." readonly>
//
// On click, copies the value of the target element (input.value or textContent)
// to the clipboard and briefly swaps the button's inner text for `data-copy-label`.
document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-copy-target]");
  if (!button) return;

  event.preventDefault();
  const target = document.querySelector(button.dataset.copyTarget);
  if (!target) return;

  const text = "value" in target ? target.value : target.textContent;

  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const helper = document.createElement("textarea");
    helper.value = text;
    helper.setAttribute("readonly", "");
    helper.style.position = "absolute";
    helper.style.left = "-9999px";
    document.body.appendChild(helper);
    helper.select();
    document.execCommand("copy");
    document.body.removeChild(helper);
  }

  const labelSpan = button.querySelector("[data-copy-label-text]");
  if (!labelSpan) return;
  const original = labelSpan.textContent;
  labelSpan.textContent = button.dataset.copyLabel || original;
  button.classList.add("text-success-700");
  setTimeout(() => {
    labelSpan.textContent = original;
    button.classList.remove("text-success-700");
  }, 1500);
});
